import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const Wrapper = styled.div`
  border-radius: 10px;
  box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.06);
  margin: 20px 0;
`;

export const Tab = styled.div`
  width: 100%;
  overflow: hidden;

  &:first-of-type > label {
    border-radius: 10px 10px 0 0;
  }

  &:last-of-type:not([data-checked='true']) > label {
    border-radius: 0 0 10px 10px;
  }

  &:last-of-type:first-of-type:not([data-checked='true']) > label {
    border-radius: 10px 10px 10px 10px;
  }

  &:not(:last-of-type) {
    margin-bottom: 4px;
  }
`;

export const Label = styled.label<{ type?: 'store' }>`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 15px 25px;
  background: ${(props) =>
    props.type === 'store'
      ? `${props.theme.color.blue.lightBlue}!important`
      : props.theme.color.light.shadeLighter};
  color: ${(props) =>
    props.type === 'store' ? props.theme.color.blue.default : props.theme.color.medium.shade};
  cursor: pointer;
  font-size: 16px;
  ${mediaQuery('small')} {
    font-size: 14px;
  }
  font-weight: 700;

  & [data-accordion-icon] {
    width: 25px;
    text-align: center;
    transition: all 300ms ease-in-out;
  }
`;

export const IconTitleWrapper = styled.div<{ maxLabelWidth?: boolean }>`
  display: flex;
  gap: 12px;
  align-items: center;
  ${(props) => props.maxLabelWidth && 'width: 100%;'}
`;

export const Content = styled.div`
  max-height: 0;
  transition: all 300ms ease-in-out;
`;

export const Input = styled.input<{ noScroll: boolean }>`
  position: absolute;
  opacity: 0;
  z-index: -1;
  &:checked {
    + [data-accordion-label] {
      /* background: green; */
      & [data-accordion-icon] {
        transform: rotate(90deg);
      }
    }
    ~ [data-accordion-content] {
      max-height: ${(props) => (props.noScroll ? 'inherit' : '100vh')};
    }
  }
`;
